import React from 'react'

import { Field, Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Button, Col, Row, Divider } from '_zari/core'

import * as CompaniaCrud from 'services/compania.service'

import * as FormGroups from './formGroups'

import validationSchema from './validacion'
import getValoresIniciales from './valoresIniciales'

const CompaniaFichaPage = ({ dataCompania }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return getValoresIniciales(dataCompania)
  }, [dataCompania])

  const submitHandler = async data => {
    const payload = {
      ...data,
      montoAprobacionOrdenCompra:
        data.montoAprobacionOrdenCompra === '' || data.montoAprobacionOrdenCompra == null
          ? null
          : Number(data.montoAprobacionOrdenCompra)
    }
    await CompaniaCrud.self
      .actualizarCompania(payload)
      .then(() => __zariContext.snack('success', 'Datos actualizados.'))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={validationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched, values, setValues, handleChange, setFieldValue }) => (
          <Form>
            <Divider title='Datos Básicos' noMargin />
            <Row>
              <Col sm={4}>
                <FormGroups.RucFormGroup
                  iError={errors.ruc}
                  iTouched={touched.ruc}
                  fIsSubmitting={isSubmitting}
                  setFieldValue={setFieldValue}
                  vRuc={values.ruc}
                />
              </Col>
              <Col sm={8}>
                <FormGroups.RazonSocialFormGroup
                  iError={errors.razonSocial}
                  iTouched={touched.razonSocial}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <FormGroups.UbigeoFormGroup
                  iError={errors.ubigeo}
                  iTouched={touched.ubigeo}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col sm={8}>
                <FormGroups.NombreComercialFormGroup
                  iError={errors.nombreComercial}
                  iTouched={touched.nombreComercial}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
            </Row>

            <Row>
              <Col sm={4}>
                <FormGroups.UrbanizacionFormGroup
                  iError={errors.urbanizacion}
                  iTouched={touched.urbanizacion}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col sm={8}>
                <FormGroups.DireccionFormGroup
                  iError={errors.direccion}
                  iTouched={touched.direccion}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <FormGroups.DepartamentoFormGroup
                  values={values}
                  setValues={setValues}
                  handleChange={handleChange}
                  iError={errors._idDepartamento}
                  iTouched={touched._idDepartamento}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col sm={4}>
                <FormGroups.ProvinciaFormGroup
                  values={values}
                  setValues={setValues}
                  handleChange={handleChange}
                  idDepartamento={values._idDepartamento}
                  iError={errors._idProvincia}
                  iTouched={touched._idProvincia}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col sm={4}>
                <FormGroups.DistritoFormGroup
                  idProvincia={values._idProvincia}
                  iError={errors._idDistrito}
                  iTouched={touched._idDistrito}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
            </Row>
            <Divider title='Configuración de Mailing' />
            <Row>
              <Col sm={4}>
                <FormGroups.MailingServiceFormGroup
                  iError={errors.mailingService}
                  iTouched={touched.mailingService}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col sm={4}>
                <FormGroups.MailingMailFormGroup
                  iError={errors.mailingMail}
                  iTouched={touched.mailingMail}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col sm={4}>
                <FormGroups.MailingPassFormGroup
                  iError={errors.mailingPass}
                  iTouched={touched.mailingPass}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
            </Row>
            <Divider title='Configuración de SUNAT' />
            <Row>
              <Col sm={4}>
                <FormGroups.UsuarioSOLFormGroup
                  iError={errors.usuarioSOL}
                  iTouched={touched.usuarioSOL}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col sm={4}>
                <FormGroups.ClaveSOLFormGroup
                  iError={errors.claveSOL}
                  iTouched={touched.claveSOL}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
            </Row>
            <Divider title='Configuración de Parámetros' />
            <Row>
              <Col sm={6} md={4}>
                <FormGroups.FlagCodigoBarraFormGroup iValue={values.flagCodigoBarra} fIsSubmitting={isSubmitting} />
              </Col>
              <Col sm={6} md={4}>
                <FormGroups.FlagCodigoSunatFormGroup iValue={values.flagCodigoSunat} fIsSubmitting={isSubmitting} />
              </Col>
              <Col sm={6} md={4}>
                <FormGroups.FlagContabilidadFormGroup iValue={values.flagContabilidad} fIsSubmitting={isSubmitting} />
              </Col>
              <Col sm={6} md={4}>
                <FormGroups.FlagInventarioFormGroup iValue={values.inventarioHabilitado} fIsSubmitting={isSubmitting} />
              </Col>
              <Col sm={6} md={4}>
                <FormGroups.FlagLoteProductosFormGroup iValue={values.flagLoteProductos} fIsSubmitting={isSubmitting} />
              </Col>
              <Col sm={6} md={4}>
                <FormGroups.FlagMarcasFormGroup iValue={values.flagMarcas} fIsSubmitting={isSubmitting} />
              </Col>
              <Col sm={6} md={4}>
                <FormGroups.FlagOrdenDeCompraEnVentaFormGroup
                  iValue={values.flagOrdenCompraEnVentas}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col sm={6} md={4}>
                <FormGroups.FlagPlacaEnVentaFormGroup iValue={values.flagPlacaEnVentas} fIsSubmitting={isSubmitting} />
              </Col>
              <Col sm={6} md={4}>
                <FormGroups.FlagVendedorEnVentaFormGroup
                  iValue={values.flagVendedorEnVentas}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col sm={6} md={4}>
                <FormGroups.FlagConsumoEnCompraFormGroup
                  iValue={values.flagConsumoEnCompra}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col sm={6} md={4}>
                <FormGroups.FlagGrifoFormGroup iValue={values.flagGrifo} fIsSubmitting={isSubmitting} />
              </Col>
              <Col sm={6} md={4}>
                <FormGroups.FlagEnvioAutomaticoFormGroup
                  iValue={values.flagEnvioAutomatico}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col sm={6} md={4}>
                <FormGroups.FlagCentroCostoVentaFormGroup
                  iValue={values.flagCentroCostoVenta}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col sm={6} md={4}>
                <FormGroups.FlagAprobacionOrdenCompraFormGroup
                  iValue={values.flagAprobacionOrdenCompra}
                  fIsSubmitting={isSubmitting}
                  montoValue={values.montoAprobacionOrdenCompra}
                />
              </Col>
              <Col sm={6} md={4}>
                <FormGroups.FlagPermitirIngresoSoloConOCFormGroup
                  iValue={values.flagPermitirIngresoSoloConOC}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col sm={6} md={4}>
                <Field name='flagAprobacionCajaChica'>
                  {({ field }) => (
                    <Form.Checkbox
                      {...field}
                      checked={values.flagAprobacionCajaChica}
                      disabled={isSubmitting}
                      id='checkbox-flagAprobacionCajaChica'
                      label='Aprobación gerencia para Caja Chica'
                    />
                  )}
                </Field>
              </Col>
              <Col sm={6} md={4}>
                <FormGroups.FlagMostrarRazonSocialFormGroup
                  iValue={values.flagMostrarRazonSocial}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col sm={6} md={4}>
                <FormGroups.FlagPermitirVentaSinStock
                  iValue={values.flagPermitirVentaSinStock}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col sm={6} md={4}>
                <FormGroups.FlagLogo
                  iValue={values.flagLogo}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
            </Row>
            <Divider title='Configuraciones Varias' />
            <Row>
              <Col sm={1} md={1}>
                <FormGroups.FlagTasaPorTarjetaFormGroup
                  iValue={values.flagTasaPorTarjeta}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              {values.flagTasaPorTarjeta && (
                <Col sm={2} md={2}>
                  <FormGroups.TasaPorTarjetaFormGroup
                    iError={errors.tasaPorTarjeta}
                    iTouched={touched.tasaPorTarjeta}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              )}
            </Row>
            <Row>
              <Col sm={4}>
                <FormGroups.TasaValidacionCostoFormGroup
                  iError={errors.tasaValidacionCosto}
                  iTouched={touched.tasaValidacionCosto}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
            </Row>
            <Row className='mt-5'>
              <Col md={4}></Col>
              <Col md={4}>
                <Button block onClick={handleSubmit}>
                  Guardar Cambios
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default CompaniaFichaPage
